import axios from 'axios';
import Cookies from 'js-cookie';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
  namespaced: true,
  state: {
    lastStartTime: null,
    stopwatch: '000000',
    employeeTasks: [],
    employeeTaskFiltered: [],
    allTimeEntries: [],
    lastTimeEntry: {},
    descriptionUnitInfo: {
      description: Cookies.get('description') || '',
      unit: parseInt(Cookies.get('unit'), 10) || 0,
    },
    timeEntryDetailedReport: {
      count: 0,
      next: null,
      previous: null,
      results: [],
    },
    timeEntryMonitor: [],
    favoriteTasks: [],
    qualityKpis: [],
    workLocation: {
      id: 0,
      date: null,
      work_location: 'Office',
      employee: 0,
    },
    totalRemoteDays: 0,
  },
  mutations: {
    updateworkLocation(state, newInfo) {
      state.workLocation = newInfo;
    },
    updateEmployeeTask(state, newEmployeeTask) {
      state.employeeTasks = newEmployeeTask;
    },
    updateEmployeeTaskFiltered(state, newEmployeeTasks) {
      state.employeeTaskFiltered = newEmployeeTasks;
    },
    allTimeEntries(state, newTimeEntry) {
      state.allTimeEntries = newTimeEntry;
    },
    lastTimeEntry(state, newLastTimeEntry) {
      state.lastTimeEntry = newLastTimeEntry;
    },
    updateTimeEntryDetailedRepoort(state, newReport) {
      state.timeEntryDetailedReport = newReport;
    },
    updateDescriptionUnit(state, newInfo) {
      state.descriptionUnitInfo = newInfo;
      Cookies.set('description', newInfo.description, { expires: 30 });
      Cookies.set('unit', newInfo.unit, { expires: 30 });
    },
    updateTimeEntryMonitor(state, newInfo) {
      state.timeEntryMonitor = newInfo;
    },
    updateLastStartTime(state, newInfo) {
      state.lastStartTime = newInfo;
    },
    updateStopwatch(state, newInfo) {
      state.stopwatch = newInfo;
    },
    updateFavoriteTasks(state, newInfo) {
      state.favoriteTasks = newInfo;
    },
    updateQualityKpis(state, newInfo) {
      state.qualityKpis = newInfo;
    },
    updateTotalRemoteDays(state, newInfo) {
      state.totalRemoteDays = newInfo;
    },
  },
  actions: {
    updateStopwatch(context, newInfo) {
      context.commit('updateStopwatch', newInfo);
    },
    saveDescriptionUnit(context, newInfo) {
      context.commit('updateDescriptionUnit', newInfo);
    },
    getEmployeeTasks(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/tasks/employee-tasks/',
          method: 'get',
        })
          .then((response) => {
            context.commit('updateEmployeeTask', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateEmployeeTask', []);
            reject(error.response.data);
          });
      });
    },
    getEmployeeTasksById(context, employeeId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/tasks/employee-tasks/${employeeId}/`,
          method: 'get',
        })
          .then((response) => {
            context.commit('updateEmployeeTaskFiltered', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateEmployeeTaskFiltered', []);
            reject(error.response.data);
          });
      });
    },
    getAllTimeEntries(context) {
      const d = new Date();
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/all-daily-entry/',
          method: 'post',
          data: {
            start_date: d,
          },
        })
          .then((response) => {
            context.commit('allTimeEntries', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('allTimeEntries', []);
            reject(error.response.data);
          });
      });
    },
    getAllTimeEntryAdjust(context, requestInfo) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/all-entry-adjust/',
          method: 'post',
          data: requestInfo,
        })
          .then((response) => {
            context.commit('allTimeEntries', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('allTimeEntries', []);
            reject(error.response.data);
          });
      });
    },
    getTimeTrackerHours(context, inputData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/report/hours/',
          method: 'post',
          data: inputData,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
    getTimeEntryDetailedReport(context, lazyParams) {
      const pageNumber = lazyParams.page + 1;
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/time-tracker/report/detailed/?page=${pageNumber}`,
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            context.commit('updateTimeEntryDetailedRepoort', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateTimeEntryDetailedRepoort', []);
            reject(error);
          });
      });
    },
    getTimeEntryKpi(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/kpi/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTimeEntryAht(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/aht/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async getTimeEntryAhtExcel(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/aht/',
          method: 'post',
          data: lazyParams,
          responseType: 'blob',
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getWeekly(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/weekly/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async getTimeEntryDetailedExcel(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/report/detailed-export/',
          method: 'post',
          data: lazyParams,
          responseType: 'blob',
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async getTimeEntryExcel(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/kpi/',
          method: 'post',
          data: lazyParams,
          responseType: 'blob',
        })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTimeEntryMonitor(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/report/monitor/',
          method: 'get',
          data: lazyParams,
        })
          .then((response) => {
            context.commit('updateTimeEntryMonitor', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateTimeEntryMonitor', []);
            reject(error);
          });
      });
    },
    getTimeEntrySummarizedReport(context, lazyParams) {
      const pageNumber = lazyParams.page + 1;
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/time-tracker/report/summarized/?page=${pageNumber}`,
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            context.commit('updateTimeEntryDetailedRepoort', response.data);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateTimeEntryDetailedRepoort', []);
            reject(error);
          });
      });
    },
    getLastTimeEntry(context) {
      console.log('invoked');
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/last-daily-entry/',
          method: 'get',
        })
          .then((response) => {
            context.commit('lastTimeEntry', response.data);
            const startTime = new Date(response.data.start_time);
            context.commit('updateLastStartTime', startTime);
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('lastTimeEntry', []);
            context.commit('updateLastStartTime', null);
            reject(error.response.data);
          });
      });
    },
    postTimeEntry(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/add/',
          method: 'post',
          data: formData,
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    startTimeEntry(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/start/',
          method: 'post',
          data: formData,
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    resumeTimeEntry(context, formData) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/resume/',
          method: 'post',
          data: formData,
        })
          .then((response) => {
            console.log('Resume Response Data.js', response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log('Resume Error.js', error);
            reject(error);
          });
      });
    },
    async updateTimeEntry(context, timeEntry) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/update/',
          method: 'put',
          data: timeEntry,
        })
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    async stopTimeEntry(context, timeEntry) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/stop/',
          method: 'put',
          data: timeEntry,
        })
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    deleteTimeEntry(context, entryId) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/delete/',
          method: 'delete',
          data: {
            id: entryId,
          },
        })
          .then((response) => {
            console.log('deleteTimeEntry');
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data);
          });
      });
    },
    getFavoriteTasks(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/favorite-tasks/',
          method: 'get',
        })
          .then((response) => {
            context.commit('updateFavoriteTasks', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateFavoriteTasks', []);
            reject(error);
          });
      });
    },
    addFavoriteTask(context, taskId) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/favorite-tasks/add/',
          method: 'post',
          data: {
            task: taskId,
          },
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    deleteFavoriteTask(context, entryId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/favorite-tasks/delete/${entryId}/`,
          method: 'delete',
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
    getDailyEntryKpi(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/kpi/team/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getDayEntryKpi(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/time-tracker/kpi/day/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getQualityKpis(context, lazyParams) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/quality-kpi/',
          method: 'post',
          data: lazyParams,
        })
          .then((response) => {
            context.commit('updateQualityKpis', response.data);
            console.log('kpi data', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            context.commit('updateQualityKpis', []);
            reject(error);
          });
      });
    },
    saveQualityKpi(context, qualityKpiData) {
      const requestMethod = qualityKpiData.id === 0 ? 'post' : 'put';
      const urlAction = qualityKpiData.id === 0 ? 'create' : 'update';
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/quality-kpi/${urlAction}/`,
          method: requestMethod,
          data: qualityKpiData,
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    deleteQualityKpi(context, entryId) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/quality-kpi/${entryId}/delete/`,
          method: 'delete',
        })
          .then((response) => {
            console.log(response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error.response.data);
          });
      });
    },
    saveWorkLocation(context, workLocationInfo) {
      const requestMethod = workLocationInfo.id === 0 ? 'post' : 'put';
      const urlId = workLocationInfo.id === 0 ? '' : `${workLocationInfo.id}/`;
      console.log('requestMethod', requestMethod);
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/work-location/${urlId}`,
          method: requestMethod,
          data: workLocationInfo,
        })
          .then((response) => {
            context.commit('updateworkLocation', response.data);
            console.log('save data', response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            context.commit('updateworkLocation', {
              id: 0,
              date: null,
              work_location: 'Office',
              employee: 0,
            });
            reject(error);
          });
      });
    },
    getWorkLocation(context, workLocationInfo) {
      return new Promise((resolve, reject) => {
        axios({
          url: `/api/daily_operation/work-location/${workLocationInfo.date}/`,
          method: 'get',
        })
          .then((response) => {
            context.commit('updateworkLocation', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTotalRemoteWork(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/daily_operation/total-work-remote/',
          method: 'get',
        })
          .then((response) => {
            context.commit('updateTotalRemoteDays', response.data.result);
            resolve(response.data.result);
          })
          .catch((error) => {
            context.commit('updateTotalRemoteDays', []);
            reject(error);
          });
      });
    },
  },
  getters: {
    getEmployeeTasks(state) {
      return state.employeeTasks;
    },
    getAllTimeEntries(state) {
      return state.allTimeEntries;
    },
    getLastTimeEntry(state) {
      return state.lastTimeEntry;
    },
    getTimeEntryDetailedReport(state) {
      return state.timeEntryDetailedReport;
    },
    getDescriptionUnitInfo(state) {
      return state.descriptionUnitInfo;
    },
    getEmployeeTaskFiltered(state) {
      return state.employeeTaskFiltered;
    },
    getTimeEntryMonitor(state) {
      return state.timeEntryMonitor;
    },
    getLastStartTime(state) {
      return state.lastStartTime;
    },
    getStopwatch(state) {
      return state.stopwatch;
    },
    getFavoriteTasks(state) {
      return state.favoriteTasks;
    },
    getQualityKpis(state) {
      return state.qualityKpis;
    },
    workLocation(state) {
      return state.workLocation;
    },
    getTotalRemoteDays(state) {
      return state.totalRemoteDays;
    },
  },
};
